var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_305_22166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 260,
    height: 260
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 0H0V260H260V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_305_22166)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_305_22166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 220C179.706 220 220 179.706 220 130C220 80.2944 179.706 40 130 40C80.2944 40 40 80.2944 40 130C40 179.706 80.2944 220 130 220Z",
    fill: "url(#paint0_linear_305_22166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 219.5C179.429 219.5 219.5 179.429 219.5 130C219.5 80.5705 179.429 40.5 130 40.5C80.5705 40.5 40.5 80.5705 40.5 130C40.5 179.429 80.5705 219.5 130 219.5Z",
    stroke: "url(#paint1_linear_305_22166)",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187 130C187 98.5198 161.48 73 130 73C98.5198 73 73 98.5198 73 130C73 161.48 98.5198 187 130 187C161.48 187 187 161.48 187 130Z",
    fill: "#F8FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5 130C186.5 98.7959 161.204 73.5 130 73.5C98.7959 73.5 73.5 98.7959 73.5 130C73.5 161.204 98.7959 186.5 130 186.5C161.204 186.5 186.5 161.204 186.5 130Z",
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii_305_22166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175 130C175 105.147 154.853 85 130 85C105.147 85 85 105.147 85 130C85 154.853 105.147 175 130 175C154.853 175 175 154.853 175 130Z",
    fill: "url(#paint2_linear_305_22166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.25 130C174.25 105.561 154.439 85.75 130 85.75C105.561 85.75 85.75 105.561 85.75 130C85.75 154.439 105.561 174.25 130 174.25C154.439 174.25 174.25 154.439 174.25 130Z",
    stroke: "url(#paint3_linear_305_22166)",
    strokeOpacity: 0.4,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.652 109.609H121.405L152.844 152.874H140.356L109.652 109.609Z",
    fill: "url(#paint4_linear_305_22166)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.349 128.824L107.156 144.99H118.615L125.326 135.854L120.349 128.824Z",
    fill: "url(#paint5_linear_305_22166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.623 121.528C144.329 121.528 148.143 118.304 148.143 114.327C148.143 110.35 144.329 107.126 139.623 107.126C134.917 107.126 131.102 110.35 131.102 114.327C131.102 118.304 134.917 121.528 139.623 121.528Z",
    fill: "url(#paint6_linear_305_22166)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130 259.5C201.521 259.5 259.5 201.521 259.5 130C259.5 58.4791 201.521 0.5 130 0.5C58.4791 0.5 0.5 58.4791 0.5 130C0.5 201.521 58.4791 259.5 130 259.5Z",
    stroke: "url(#paint7_linear_305_22166)",
    strokeOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_305_22166",
    x: 0,
    y: -12,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_305_22166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_305_22166",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii_305_22166",
    x: 70,
    y: 74,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_305_22166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_305_22166",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_305_22166"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_305_22166",
    result: "effect3_innerShadow_305_22166"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_22166",
    x1: 130,
    y1: 40,
    x2: 130,
    y2: 220,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177238,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_305_22166",
    x1: 130,
    y1: 40,
    x2: 130,
    y2: 220,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_305_22166",
    x1: 85,
    y1: 86.4062,
    x2: 173.594,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0693659,
    stopColor: "#303032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236535,
    stopColor: "#1B1B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436021,
    stopColor: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596091,
    stopColor: "#18181A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#303032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18181A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_305_22166",
    x1: 130,
    y1: 85,
    x2: 130,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_305_22166",
    x1: 112.704,
    y1: 128.29,
    x2: 151.902,
    y2: 129.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90959E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F2F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_305_22166",
    x1: 108.44,
    y1: 135.804,
    x2: 124.928,
    y2: 136.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90959E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F2F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_305_22166",
    x1: 132.306,
    y1: 113.345,
    x2: 147.77,
    y2: 113.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90959E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F2F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_305_22166",
    x1: 130,
    y1: -7.82994e-9,
    x2: 130,
    y2: 260,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.e8f6af39837eb05d9e886349777f8b60.svg";
export { ForwardRef as ReactComponent };